import React, { useEffect, useState } from 'react'
import { Image, SwipeAction, Modal } from 'antd-mobile'
import general, { redux } from '../../../general'
import Dialog from '../../../lib/Dialog'
import moment from 'moment'
import { useScroll } from 'ahooks'
import { CSSTransition } from 'react-transition-group'
import './css/message.css'

export default function MessageList(props) {

  const { general_type, subtype } = props
  const [editItem, setEditItem] = useState({})
  const [messageList, setMessageList] = useState([])
  const [more, setMore] = useState(false)
  const [loading, setLoading] = useState(false)
  const [page, setPage] = useState(1);
  const [init, setInit] = useState(false);

  const [vipMenuSign, setVipMenuSign] = useState([]);
  const [paying, setPaying] = useState(false);
  const [payUrl, setPayUrl] = useState();
  const [temporaryUrl, setTemporaryUrl] = useState(); //新的临时的支付链接 20220408
  const [price, setPrice] = useState(0);
  const [vipcard, setVipcard] = useState(false)

  useEffect(() => {
    redux.subscribe(() => {
      const state = redux.getState();
      if (state.deleteMessageId) {
        let tmp = messageList.filter(i => i.message_id != state.deleteMessageId)
        setMessageList(tmp)
      }
      if (state.readMessageId) {
        let tmp = messageList.map(i => {
          if (i.message_id == state.readMessageId) {
            i.read_tag = 1
          }
          return i
        })
        setMessageList(tmp)
      }
      if (state.readAllType) {
        const readAllType = state.readAllType;
        let tmp = messageList.map(item => ({
          ...item,  
          read_tag: readAllType === item.subtype ? 1 : item.read_tag
        }));
        setMessageList(tmp)
      }
      if (state.deleteAllType) {
        const deleteAllType = state.deleteAllType;
        let tmp = messageList.filter(i => i.subtype != deleteAllType)
        setMessageList(tmp)
      }
    })
  }, [messageList]);

  const deleteMessage = (item, operate_type) => {
    if (loading) {
      return
    }
    setLoading(true)
    general.axios.post('/singleOperateMess', {
      message_mixid: item.message_mixid,
      operate_type,
      tagid: item.tagid,
      circles_type: item.circles_type
    })
      .then(res => {
        setLoading(false)
        redux.dispatch({
          type: 'deleteMessage',
          data: {
            deleteMessageId: item.message_id,
          }
        })
      })
  }

  const handleReadMessage = (item) => {
    general.axios.post('/singleOperateMess', {
      message_mixid: item.message_mixid,
      operate_type: 1,
      tagid: item.tagid,
      circles_type: item.circles_type
    }).then(res => {
      redux.dispatch({
        type: 'readMessage',
        data: {
          readMessageId: item.message_id,
        }
      })
    })
  }

  const deleteAlert = (item, operate_type) => {
    Modal.show({
      title: '温馨提示',
      closeOnMaskClick: true,
      className: 'game-sign-title',
      content: (
        <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
          <div style={{ fontSize: 12, color: '#666', padding: 5 }}>确认删除吗?</div>
          <div onClick={() => {
            deleteMessage(item, operate_type)
            Modal.clear()
          }} style={{ backgroundColor: 'var(--MainColor)', width: '183px', height: '44px', color: 'white', fontSize: '15px', textAlign: 'center', borderRadius: '22px', lineHeight: '44px', marginTop: '10px' }}>确认</div>
          <div onClick={() => {
            Modal.clear()
          }} style={{ fontSize: '13px', color: '#999', paddingTop: '10px' }}>取消</div>
        </div>
      ),
    })
  }

  const rightActions = [
    {
      key: 'delete',
      text: '删除',
      color: 'danger',
      onClick: (e) => {
        deleteAlert(e, 2)
      }
    },
  ]

  const load = (parms = {}) => {
    if (loading) {
      return
    }
    let tmp = {
      pagination: { count: 20 },
    };
    if (parms.page) {
      tmp.pagination.page = parms.page;
    }
    Dialog.loading()
    setLoading(true)
    general.axios.post('/getGeneralMessageEntry', {
      general_type,
      subtype,
      pagination: tmp.pagination
    })
      .finally(() => {
        Dialog.close()
      })
      .then(res => {
        let { status, data: { message_list, paginated } } = res.data;
        if (!status.succeed) {
          Dialog.error(status.error_desc);
        } else {
          setMessageList(parms.page > 1 ? [...messageList, ...message_list] : message_list)
          setLoading(false)
          setInit(true)
          if (parms.page) {
            setPage(parms.page);
          }
          setMore(paginated.more && message_list.length > 0);
        }
      })
  }

  useEffect(() => {
    if (props.active && !init) {
      load({ page: 1 })
    }
  }, [props.active, init]);

  const scroll = useScroll()
  useEffect(() => {
    if (props.active) {
      if (scroll.top < -50) {
        load({ page: 1 });
      }
      const height = Math.max(
        document.body.scrollHeight,
        document.body.offsetHeight,
        document.documentElement.clientHeight,
        document.documentElement.scrollHeight,
        document.documentElement.offsetHeight
      );
      if (scroll.top + window.innerHeight + 20 >= height && more) {
        load({ page: page + 1 });
      }
    }
  }, [scroll, props.active])

  //系统消息点击
  const handleClickMessage = item => {
    handleReadMessage(item)
    if (item.message_type == '3') {
      // 返利消息
      general.history.push('/rebate/detail?id=' + item.message_params);
    } else if (item.message_type == '2') {
      Dialog.confirm({
        title: item.content,
        yes: () => {
          Dialog.loading();
          general.axios.post('/base/receiveBalance', { id: item.message_params })
            .finally(() => {
              Dialog.close();
            })
            .then(res => {
              let { status, data } = res.data;
              if (status.succeed !== 1) {
                Dialog.info(status.error_desc);
              } else {
                Dialog.info('领取成功');
                load();
              }
            })
            .catch(err => {
              Dialog.error(err.message);
            });
        },
      });
    } else if (item.message_type == '1') {
      // 招募
      general.messagenew = item;
      general.history.push('/message/new');
    } else if (item.message_type == '2' || item.message_type == '4') {
      // 官方
      general.history.push('/message/infobox?id=' + item.message_id);
    } else if (item.message_type == '5') {
      //会员到期提醒
      general.history.push('/save/newvip');
    } else if (item.message_type == '6') {
      //至尊版到期提醒
      setVipMenuSign(item);

      let payUrl = item.supremePayUrl + "&from=react";
      setPayUrl(payUrl + "&version=20220408&amount=" + item.vipSignMenu.items[0].price);
      setTemporaryUrl(payUrl);
      setPrice(item.vipSignMenu.items[0].price);
      setVipcard(true);
      return;
    } else if (item.message_type == '0') {
      // 交易消息
      general.history.push('/trade/detail?id=' + item.link_value);
    } else if (item.message_type == '18') {
      // 出价
      general.history.push('/modifyprice?id=' + item.link_value);
    } else if (item.message_type == '19') {
      // 改价
      general.history.push('/trade/detail?id=' + item.link_value);
    } else if (item.message_type == '8' || item.message_type == '9' || item.message_type == '23') {
      general.history.push('/communityDetail?id=' + item.link_value + '&tagid=' + item.tagid + '&circles_type=' + item.circles_type + '&topic_id=' + item.topic_id);
    } else if (item.message_type == '20' || item.message_type == '21' || item.message_type == '22') {
      general.history.push('/growthlevel')
    }
  }

  return (
    <div>
      <div className='message-page-index'>
        <div className='message-list'>
          {messageList.map((item, index) =>
            <SwipeAction
              stopPropagation={['click']}
              key={item.message_id + '_' + index}
              rightActions={rightActions}
              onAction={action => action.onClick(item)}
              onClose={() => setEditItem({})}
            >
              <div className='message-item-container' onClick={() => handleClickMessage(item)}>
                <div className="message-container">
                  {general_type == 'community' && <Image
                    className='message-avatar'
                    src={item.avatar}
                    alt="Message Image"
                  />}
                  <div className='message-item'>
                    <div className='message-content'>
                      <div className="message-title">{item.title}</div>
                      <div className="message-time">{moment(item.message_time * 1000).format('MM-DD HH:mm')}</div>
                    </div>
                    <div className="message-content">
                      <div className="message-body">{item.content}</div>
                      {parseInt(item.read_tag) == 0 && <div className="message-status"></div>}
                    </div>
                  </div>
                </div>
              </div>

            </SwipeAction>
          )}
        </div>
        {messageList.length === 0 && init && <div className="empty"><img src="/resources/empty.png" alt="" />暂无消息</div>}
      </div>

      <CSSTransition in={paying} timeout={250} unmountOnExit={true}>
        <div className="game-save-pay">
          <div className="mask" onClick={() => setPaying(null)} />
          <div className="container">
            <div className="title">支付</div>
            <iframe src={payUrl} />
          </div>
        </div>
      </CSSTransition>


      <CSSTransition in={vipcard} timeout={250} unmountOnExit={true}>
        <div className="game-vipcard-detail">
          <div className="vipcard-mask" />
          <div className="vipcard-container">
            <div className="vipcard-top">
              <div className="text">
                <div className="name">{vipMenuSign?.vipSignMenu?.title} <img src="/resources/game/tips-wh.png" onClick={() => Dialog.alert('温馨提示', vipMenuSign?.vipSignMenu?.bottomTips)} /></div>
                <div className="desc">{vipMenuSign?.vipSignMenu?.comment1}</div>
                <div className="useful">
                  {vipMenuSign?.vipSignMenu?.useDesc}
                </div>
              </div>
              <div className="close" onClick={() => {
                setVipcard(false);
              }}>
                <img src="/resources/party/couple-close.png" />
              </div>
            </div>
            <div className="vipcard-tips">
              {vipMenuSign?.vipSignMenu?.comment2}
            </div>
            <div className={"vipcard-main " + (vipMenuSign?.vipSignInfo?.isRealBuy ? "renewal" : "")}>
              {
                vipMenuSign?.vipSignMenu?.items.map((item, index) => <div className={"item " + (index == vipRouterIndex ? 'active' : '')} onClick={() => { setVipRouterIndex(index); setPayUrl(temporaryUrl + '&version=20220408&amount=' + item.price); setPrice(item.price) }}>
                  {item.topLable ?
                    <div className="good" style={{ backgroundImage: 'url(/resources/game/vipcard-good.png)' }}>
                      {item.topLable}
                    </div>
                    : null
                  }
                  <div className="price">￥<span>{item.price}</span></div>
                  <div className="tag">{item.buttonTitle}</div>
                  <div className="tip2">
                    <div className="intro">{item.comment1}</div>
                    <div className="object">{item.comment2}</div>
                  </div>
                </div>)
              }
            </div>
            <div className="vipcard-bottom" onClick={() => {
              setPaying(true);
            }} >{vipMenuSign?.vipSignMenu?.items[vipRouterIndex].submitButtonTitle}</div>
          </div>
        </div>
      </CSSTransition>
    </div>
  )
}
